import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";
import { cn } from "@/lib/utils";

/** Tab set root. `<Tabs defaultValue="cards">` with a TabList and one TabContent per tab. */
export const Tabs = TabsPrimitive.Root;

export const TabList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-12 items-center gap-1 rounded-[var(--radius-lg)] border border-ds-gold-primary/20 bg-ds-black-secondary/80 p-1 backdrop-blur-md",
      className,
    )}
    {...props}
  />
));
TabList.displayName = "TabList";

export const Tab = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex h-full items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius-md)] px-4",
      "font-heading text-[length:var(--font-size-sm)] font-semibold tracking-wide text-ds-text-muted",
      "transition-[color,background-color,box-shadow] duration-300 ease-in-out hover:text-ds-gold-accent",
      "focus-visible:outline-none focus-visible:shadow-[var(--focus-ring)] disabled:pointer-events-none disabled:opacity-50",
      "data-[state=active]:bg-ds-gold-primary/15 data-[state=active]:text-ds-gold-light data-[state=active]:shadow-[inset_0_0_0_1px_rgba(212,175,55,0.55)]",
      "[&_svg]:size-4 [&_svg]:shrink-0",
      className,
    )}
    {...props}
  />
));
Tab.displayName = "Tab";

export const TabContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-6 rounded-[var(--radius-lg)] focus-visible:outline-none focus-visible:shadow-[var(--focus-ring)]",
      className,
    )}
    {...props}
  />
));
TabContent.displayName = "TabContent";
